import { type } from "skin/event";

export default function refPartner(v) {
	type('partner');
	return false;
}